import { palette } from '../../../../styles/material-ui/palette'

/** @type {Styles} */
export const styles = {
  tabListContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomColor: 'gray.8',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
  buttonsContainer: {
    display: 'flex',
    gap: 1,
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      borderRadius: '100px 100px 0 0',
      width: '100%',
      backgroundColor: 'primary.main',
    },
  },
  tabList: {
    borderBottom: 'none',
    display: 'flex',
    flexWrap: 'wrap',
  },
  tab: {
    color: 'gray.64',
    fontSize: { xs: 12, sm: 14 },
    // flex: '1 0 33.33%',
    whiteSpace: 'normal',
    overflow: 'hidden',
    textAlign: 'center',
    padding: 2,
    height: 'auto',
    '&.Mui-disabled': {
      color: (theme) => theme.palette.gray[40],
    },
  },
  tabPanel: {
    color: 'gray.64',
    padding: 0,
  },
  wrapVertical: {
    marginTop: { xs: 0, md: 1 },
  },
}
